import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {GamePlaceHolderBox} from './boxes/placeholder/game-placeholder.box';
import {GameImageBox} from './boxes/game-image/game-image.box';
import {GameImageContainerBox} from '../single-game/regular-template/boxes/game-image-container/game-image-container.box';
import {observer} from 'mobx-react';
import {GAME_IMAGE_CONTAINER, SWIPER_MODE} from '../single-game/css-constants';
import classNames from 'classnames';

export interface SingleGamePlaceholderComponentProps {
    isInsideSwiper: boolean
}

export const SingleGamePlaceholderComponent = observer(
  class SingleGamePlaceholderComponent extends OrbitComponent<SingleGamePlaceholderComponentProps> {
    render() {
      return (
        <GamePlaceHolderBox className={classNames('cy-game-placeholder', {[SWIPER_MODE]: this.props.isInsideSwiper})}>
            <GameImageContainerBox className={GAME_IMAGE_CONTAINER}>
              <GameImageBox src={this.services.theme.currentTheme.images.emptyImage.toString()}></GameImageBox>
            </GameImageContainerBox>
        </GamePlaceHolderBox>
      );
    }
  }
);
